import { render, staticRenderFns } from "./TransactionsEmpty.vue?vue&type=template&id=27d051e4&scoped=true&"
import script from "./TransactionsEmpty.vue?vue&type=script&lang=js&"
export * from "./TransactionsEmpty.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsEmpty.vue?vue&type=style&index=0&id=27d051e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d051e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
